import React from 'react'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import { Doughnut } from 'react-chartjs-2'
import { renderStateName } from '../../../process/util/names'

const COLOR_LIST = [
    'rgb(0,145,231)',
    'rgb(255,193,44)',
    'rgb(255,138,0)',
    'rgb(255,63,107)',
    'rgb(18,178,178)',
    'rgb(133,70,255)',
    'rgb(186,188,193)',
    'rgb(0,145,231)',
    'rgb(255,193,44)',
    'rgb(255,138,0)',
    'rgb(255,63,107)',
    'rgb(18,178,178)',
    'rgb(133,70,255)',
    'rgb(186,188,193)',
]


const compileDoughnutData = (filteredStateList) => {
    return {
        labels: filteredStateList.map(entry => {
            return renderStateName(entry.state) + ' % '
        }),
        datasets: [{
            data: filteredStateList.map(entry => {
                return entry.percentage.toFixed(2)
            }),
            backgroundColor: COLOR_LIST,
            hoverBackgroundColor: COLOR_LIST,
        }],
    }
}

const CurrentState = ({ currentState, enrichedStateList, filteredStateList }) => {
    if (!currentState) {
        return null
    }
    return (<ContentBox title="Current State">
        <Row>
            <Column size={6}><Doughnut data={compileDoughnutData(filteredStateList)}/></Column>
            <Column size={6}>
                <table className="default-table">
                    <thead>
                        <tr>
                            <th>State</th>
                            <th>Absolute</th>
                            <th>Percentage</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            enrichedStateList.map((state, index) => {
                                return (<tr key={index}>
                                    <td>{renderStateName(state.state)}</td>
                                    <td className="align-right">{state.count}</td>
                                    <td className="align-right">{state.percentage.toFixed(2)} %</td>
                                </tr>)
                            })
                        }
                    </tbody>

                </table>

            </Column>
        </Row>


    </ContentBox>)
}

export default CurrentState



// WEBPACK FOOTER //
// ./src/modules/analytics/component/funnel-builder/CurrentState.js